var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7527_23443",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7527_23443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7272 16.4929C3.35209 16.4929 3.03502 16.3634 2.77599 16.1044C2.51697 15.8453 2.38745 15.5283 2.38745 15.1531V6.66602C2.38745 6.29091 2.51697 5.97384 2.77599 5.71481C3.03502 5.45579 3.35209 5.32627 3.7272 5.32627H7.38745V4.07829C7.38745 3.70197 7.51715 3.38534 7.77653 3.1284C8.03592 2.87145 8.35342 2.74298 8.72903 2.74298H11.2198C11.5954 2.74298 11.9117 2.8725 12.1687 3.13152C12.4256 3.39055 12.5541 3.70761 12.5541 4.08271V5.32627H16.2143C16.5894 5.32627 16.9065 5.45579 17.1655 5.71481C17.4246 5.97384 17.5541 6.29091 17.5541 6.66602V15.1531C17.5541 15.5283 17.4246 15.8453 17.1655 16.1044C16.9065 16.3634 16.5894 16.4929 16.2143 16.4929H3.7272ZM3.7272 15.4096H16.2143C16.2784 15.4096 16.3372 15.3829 16.3906 15.3295C16.4441 15.276 16.4708 15.2173 16.4708 15.1531V6.66602C16.4708 6.60191 16.4441 6.54314 16.3906 6.48971C16.3372 6.43629 16.2784 6.40959 16.2143 6.40959H3.7272C3.66309 6.40959 3.60432 6.43629 3.55089 6.48971C3.49747 6.54314 3.47076 6.60191 3.47076 6.66602V15.1531C3.47076 15.2173 3.49747 15.276 3.55089 15.3295C3.60432 15.3829 3.66309 15.4096 3.7272 15.4096ZM8.47076 5.32627H11.4708V4.08271C11.4708 4.0186 11.4441 3.95984 11.3906 3.90642C11.3372 3.85299 11.2784 3.82627 11.2143 3.82627H8.7272C8.66309 3.82627 8.60432 3.85299 8.55089 3.90642C8.49747 3.95984 8.47076 4.0186 8.47076 4.08271V5.32627Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/job.c40f9f4f336d0bbf821e44aacb99ea1a.svg";
export { ForwardRef as ReactComponent };